import React from 'react';

import PropTypes from 'prop-types';
import { Divider, Button, Icon } from 'semantic-ui-react';

import './AddAccordionPaneButton.scss';

const propTypes = {
  onClick: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function AddAccordionPaneButton({ onClick }) {
  return (
    <Divider horizontal className="add-accordion-pane-button">
      <Button basic onClick={onClick}>
        <Icon name="plus" />
        Insert Accordion Item
      </Button>
    </Divider>
  );
}

AddAccordionPaneButton.propTypes = propTypes;
AddAccordionPaneButton.defaultProps = defaultProps;
